/**
 * is used in the admin app and in the receptionist
 */
export const buildHrefToSubdomain = (name: string) => {
  const protocol = location.protocol
  const host = location.host
  const hostParts = host.split('.')
  hostParts.shift()

  const url = `${protocol}//${name}.${hostParts.join('.')}`
  return url
}
